import { Text } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { MealTypesLegacy } from '@spa/constants/MealTypes'
import styles from '@spa/scenes/Plannings/Forms/RealHoursForms/components/MealCol/MealCol.module.css'
import type { FC } from 'react'

type Props = {
  mealType?: string
}

const MealTaken: FC<Props> = ({ mealType }) => {
  const { tCommon } = usePlanningFormTranslation()
  if (!mealType) {
    return
  }

  const mealTypeInfo = MealTypesLegacy.get(mealType)

  if (!mealTypeInfo) {
    return null
  }

  return (
    <div className={styles.Row}>
      <Text as='span' size='m'>
        {tCommon(mealTypeInfo.name)}
      </Text>
      <Text as='span' size='m' className={styles.Icon}>
        {mealTypeInfo.icon}
      </Text>
    </div>
  )
}

export default MealTaken
